module.exports = __webpack_public_path__ + "static/img/logo.0aff902.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/image/logo.png
// module id = P+yp
// module chunks = 1